/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { BigBoardService } from './services/big-board.service';
import { CompetitionService } from './services/competition.service';
import { ConferenceService } from './services/conference.service';
import { MenuService } from './services/menu.service';
import { MetadataService } from './services/metadata.service';
import { PlayerService } from './services/player.service';
import { PlayerNotesService } from './services/player-notes.service';
import { RateService } from './services/rate.service';
import { TeamService } from './services/team.service';
import { UserService } from './services/user.service';
import { WatchlistService } from './services/watchlist.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    BigBoardService,
    CompetitionService,
    ConferenceService,
    MenuService,
    MetadataService,
    PlayerService,
    PlayerNotesService,
    RateService,
    TeamService,
    UserService,
    WatchlistService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
